export default __webpack_public_path__ + "static/media/invoicebanklogo.3f87a7db.jpeg";